import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Users, MessageSquare, Handshake, Award } from 'lucide-react';
import { mockDiferenciais } from '../mock';

const iconMap = {
  Users,
  MessageSquare,
  Handshake,
  Award
};

const DiferenciaisSection = () => {
  return (
    <section id="diferenciais" className="py-16 md:py-20 lg:py-24 nexti-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Diferenciais NexTI
          </h2>
          <p className="text-lg md:text-xl text-white/90 max-w-3xl mx-auto">
            Com experiência e compromisso com a excelência, a NexTI se concentra no
            crescimento e no sucesso da sua empresa.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {mockDiferenciais.map((diferencial) => {
            const IconComponent = iconMap[diferencial.icon];
            return (
              <Card
                key={diferencial.id}
                className="bg-white/10 backdrop-blur-md border-white/20 hover:bg-white/20 transition-all duration-300 hover:scale-105"
              >
                <CardHeader>
                  <div className="w-12 h-12 mb-4 text-white">
                    <IconComponent className="w-full h-full" />
                  </div>
                  <CardTitle className="text-lg font-bold text-white">
                    {diferencial.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-white/80 text-base">
                    {diferencial.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="text-center mt-16">
          <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Tecnologia confiável para empresas que não podem parar.
          </h3>
          <p className="text-xl md:text-2xl text-white/90">
            Confie na NexTI.
          </p>
        </div>
      </div>
    </section>
  );
};

export default DiferenciaisSection;